import React, { useState, useRef } from "react";
import { IoMdClose } from "react-icons/io";
import { AuthLock } from "asset/icons";
import Loader from "component/loader";
import { useSelector } from "react-redux";
import { maskEmail } from "utilities/maskEmail";
import ErrorMessage from "pages/auth_v2/ErrorMessage";

const EnterResetCodeModal = ({ isOpen, onClose, onBack, onContinue, loading, errorMessage }) => {
    const [code, setCode] = useState(["", "", "", ""]);
    const inputRefs = useRef([]);
    const { users: user } = useSelector((state) => state);

    const businessEmail = user.email;

    const handleChange = (value, index) => {
        if (/^\d?$/.test(value)) {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
            if (value && index < 3) {
                inputRefs.current[index + 1]?.focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newCode = [...code];
            if (code[index]) {
                newCode[index] = "";
                setCode(newCode);
            } else if (index > 0) {
                inputRefs.current[index - 1]?.focus();
            }
        } else if (e.key === "ArrowLeft" && index > 0) {
            inputRefs.current[index - 1]?.focus();
        } else if (e.key === "ArrowRight" && index < code.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleSubmit = () => {
        const fullCode = code.join("");
        if (fullCode.length === 4) {
            onContinue(fullCode);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[700] bg-black/40 flex items-center justify-center">
            <div className="bg-white rounded-2xl w-full max-w-xl relative">
                <div className="px-6 pt-6">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-2xl text-[#101828]"
                    >
                        <IoMdClose />
                    </button>

                    <div className="text-start">
                        <AuthLock />

                        <div className="!px-5">
                            {errorMessage && <ErrorMessage message={errorMessage} />}
                            <h2 className="text-2xl font-semibold text-[#101828] mb-1">
                                Check your email for a code
                            </h2>
                            <p className="text-[#667085] mb-6">
                                Enter the 4-digit code sent to{" "}
                                <strong>
                                    <strong>{maskEmail(businessEmail)}</strong>
                                </strong>
                            </p>

                            {/* OTP Input */}
                            <div className="flex gap-4 mt-6 mb-3">
                                {code.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={1}
                                        value={digit}
                                        onChange={(e) => handleChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        className="w-14 h-14 !shadow-none bg-[#F2F3FC] text-center text-2xl rounded-lg"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-4 border-t !p-5 items-center mt-8 text-sm">
                    {/* <p className="text-sm text-[#667085]">
                        Didn’t receive code?{" "}
                        <button className="text-[#6F00FF] font-medium">Resend</button>
                    </p> */}

                    <div className="flex gap-4 items-center">
                        <button onClick={onBack} className="text-[#344054] font-medium">
                            Back
                        </button>
                        <button
                            onClick={handleSubmit}
                            disabled={code.some((d) => d === "") || loading}
                            className={`rounded-lg px-6 py-2 font-medium transition text-white ${
                                code.some((d) => d === "") || loading
                                    ? "bg-[#E9D7FE] text-[#B3A8DD] cursor-not-allowed"
                                    : "bg-[#6F00FF] hover:bg-[#5A00D6]"
                            }`}
                        >
                            {loading ? <Loader /> : "Continue"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnterResetCodeModal;
